import { useSyncExternalStore } from 'react'

import {
  AUTO_SAVE_CHANGE_EVENT,
  getComposerAutoSave,
} from '../../utils/autoSave'

function subscribe(listener: () => void): () => void {
  window.addEventListener(AUTO_SAVE_CHANGE_EVENT, listener)
  window.addEventListener('storage', listener)
  return (): void => {
    window.removeEventListener(AUTO_SAVE_CHANGE_EVENT, listener)
    window.removeEventListener('storage', listener)
  }
}

function getSnapshot(): boolean {
  return getComposerAutoSave() !== null
}

const getServerSnapshot = (): boolean => false

/**
 * True while a recoverable auto-saved draft exists in localStorage. Reacts
 * live to same-tab writes/clears (AUTO_SAVE_CHANGE_EVENT) and cross-tab ones
 * (the native `storage` event).
 */
export function useHasComposerAutoSave(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
